<script>
import { layoutMethods } from "@/state/helpers";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {
  reportsMethods,
  reportsComputed,
  exportMethods,
  erpFixMessages,
  kantoAdsMethods,
  kantoAdsComputed,
} from "@/state/helpers";
import Swal from "sweetalert2";
import moment from 'moment';
import { getModuleAccess } from "@/router/helper.js";
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";

export default {
  page: {
    title: "Kanto Ads Cashout Details",
  },
  data() {
    return {
      logsModalfields: [
        {
          key: "modified_by",
          sortable: true,
        },
        {
          key: "status",
          sortable: true,
        },
        {
          key: "release_date",
          sortable: true,
        },
        {
          key: "remarks",
          sortable: true,
        },
        {
          key: "modified_at",
          label: "Modified Date & Time",
          sortable: true,
        },
      ],

      search: {
        dateRange: null,
        sort: "id",
        orderDesc: true,
      },
      isRange: null,
      rangeOptions: {
        mode: "single",
        dateFormat: "F j, Y"
      },
      logsRangeOptions: {
        mode: "range",
      },
      cashout: {
        release_datetime: null,
      },
      prevCashoutValue: {},
      statusOptions: [
        { text: "Confirmed", value: "confirmed" },
        { text: "On Hold", value: "on hold" },
        { text: "Processing", value: "processing" },
        { text: "Rejected", value: "rejected" },
      ],
      showLogsModal: false,
      cashoutChangeLogs: [],
      logsCurrentPage: 1,
      logsPerPage: 10,
      logsPageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      logsSortBy: "",
      logsSortDesc: true,
      logsSortOrder: "DESC",
      logsDateRange: null,
      isSearching: false,
      cashoutModule: {
        access: {
          update: true,
        },
      },
      remarksOptions: [
        { text: "Mali ang iyong na provide na Account Number sa E-Wallet", value: "Mali ang iyong na provide na Account Number sa E-Wallet" },
        { text: "Mali ang iyong na provide na Account Name sa E-Wallet", value: "Mali ang iyong na provide na Account Name sa E-Wallet" },
        { text: "Mali ang iyong na provide na Account Number para sa Bank Transfer", value: "Mali ang iyong na provide na Account Number para sa Bank Transfer" },
        { text: "Mali ang iyong na provide na Account Name para sa Bank Transfer", value: "Mali ang iyong na provide na Account Name para sa Bank Transfer" },
        { text: "Ang iyong na provide na E-Wallet User ay hindi verified", value: "Ang iyong na provide na E-Wallet User ay hindi verified" },
        { text: "Ang iyong na provide na E-Wallet User Account ay na-exceed na ang monthly incoming limit", value: "Ang iyong na provide na E-Wallet User Account ay na-exceed na ang monthly incoming limit" },
        { text: "Ang iyong account ay nag-raise ng security concerns", value: "Ang iyong account ay nag-raise ng security concerns" },
        { text: "Ang iyong account ay nadetect as fraudulent", value: "Ang iyong account ay nadetect as fraudulent" },
      ],
      dummyReleaseDate: "",
      remarks: [],
      submitted: false,
    };
  },
  validations: {
    remarks: { required },
  },
  components: {
    flatPickr,
    Multiselect,
  },
  computed: {
    ...reportsComputed,
    ...erpFixMessages,
    ...kantoAdsComputed,
    setStatusOptions: {
      get() {
        if (
          this.prevCashoutValue.status == "confirmed" ||
          this.prevCashoutValue.status == "rejected"
        ) {
          return this.statusOptions.map((status) => {
            status.disabled = true;
            return status;
          });
        } else {
          return this.statusOptions;
        }
      },
    },
  },
  async mounted() {
    this.changeTitle({ title: "Update Wallet Cashout" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: "Kanto Ads", to: { name: "" } },
        { text: "Wallet Cashout", to: { name: "KantoAdsCashout" } },
        { text: "Wallet Cashout Form", to: { name: "KantoAdsCashoutDetails" } },
      ],
    });

    if (this.$route.params.id != undefined) {
      await this.getMcpCashout({ cashoutId: this.$route.params.id }).then(() => {
        this.cashout = JSON.parse(JSON.stringify(this.mcpCashout));
        this.prevCashoutValue = JSON.parse(JSON.stringify(this.mcpCashout));
        this.cashout.remarks = this.cashout.remarks != "null" ? this.cashout.remarks : "";
        this.cashout.internal_remarks = this.cashout.internal_remarks != "null" ? this.cashout.internal_remarks : "";
        this.prevCashoutValue.remarks = this.cashout.remarks != "null" ? this.cashout.remarks : "";
        this.prevCashoutValue.internal_remarks = this.cashout.internal_remarks != "null" ? this.cashout.internal_remarks : "";
        if (this.cashout.status == 'on hold' || this.cashout.status == 'rejected') {
          this.remarksOptions.forEach(item => {
            this.cashout.remarks.forEach(remark => {
              if (item.value == remark.value) {
                this.remarks.push(item)
              }
            })
          })
        }
      });
    }

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess("Products", "Kanto Ads", "Wallet Cashout").then(
      (access) => (this.cashoutModule.access = access)
    );
  },
  methods: {
    ...layoutMethods,
    ...reportsMethods,
    ...exportMethods,
    ...kantoAdsMethods,
    async updateCashout() {
      this.submitted = true;
      this.$v.$touch();

      if ((this.cashout.status == 'on hold' && this.$v.remarks.$invalid) || (this.cashout.status == 'rejected' && this.$v.remarks.$invalid)) {
        return;
      }

      if (this.cashout.status == 'on hold' || this.cashout.status == 'rejected') {
        this.cashout.remarks = this.remarks.map(r => {
          return {
            value: r.value
          }
        });
        this.cashout.remarks = JSON.stringify(this.cashout.remarks);
      }

      if (
        this.cashout.status != this.prevCashoutValue.status ||
        this.cashout.remarks != this.prevCashoutValue.remarks || 
        this.cashout.release_datetime != this.prevCashoutValue.release_datetime || 
        this.cashout.internal_remarks != this.prevCashoutValue.internal_remarks
      ) {

        let releaseDate = moment(String(this.cashout.release_datetime)).format('YYYY-MM-DD');

        let params = {
          id: this.$route.params.id,
          status: this.cashout.status,
          releaseDate: releaseDate,
          remarks:
            this.cashout.remarks != null || this.cashout.remarks != ""
              ? this.cashout.remarks
              : "",
          internalRemarks: this.cashout.internal_remarks,
          updatedBy: JSON.parse(localStorage.getItem("userData")).email,
        };

        await this.updateMcpCashout(params).then(() => {
          Swal.fire(
            "Update Successful!",
            `${this.cashout.store_name} has been updated.`,
            "success"
          ).then(() => {
            this.$router.back();
          });
        }).catch((err) => {
            console.log('updateMcpCashout error: ', err)
            Swal.fire("Update Failed!", 'Unexpected error occurred.', "error")
        });
      } else {
        Swal.fire(
          "Update Successful!",
          `${this.cashout.store_name} has been updated.`,
          "success"
        ).then(() => {
          this.$router.back();
        });
      }
    },
    async getChangeLogs() {
      this.logsCurrentPage = this.isSearching ? 1 : this.logsCurrentPage;

      let params = {
        cashoutId: this.$route.params.id,
        dateRange: this.logsDateRange,
        page: this.isSearching ? 1 : this.logsCurrentPage,
        limit: this.isSearching ? 10 : this.logsPerPage,
        sortBy: this.isSearching ? "" : this.logsSortBy,
        sortOrder: this.isSearching ? "DESC" : this.logsOrderDesc,
      };

      this.getCashoutChangeLogs(params).then(() => {
        this.cashoutChangeLogs = JSON.parse(JSON.stringify(this.mcpCashoutChangeLogs));
        this.isSearching = false;
      });
    },
    async showReasonLogsModal() {
      this.getChangeLogs().then(() => {
        this.showLogsModal = true;
      });
    },
    closeLogsModal() {
      this.showLogsModal = false;
      this.logsDateRange = null;
      this.logsCurrentPage = 1;
      this.logsPerPage = 10;
      this.logsSortBy = "";
      this.logsSortDesc = true;
      this.logsSortOrder = "DESC";
    },
    async tableSorting(action) {
      var column = "";
      switch (action.sortBy) {
        case "modified_by":
          column = "updated_by";
          break;
        case "status":
          column = "status";
          break;
        case "release_date":
          column = "release_datetime";
          break;
        case "remarks":
          column = "remarks";
          break;
        case "modified_at":
          column = "modified_at";
          break;
      }

      this.logsSortBy = column;
      this.logsSortOrder = action.sortDesc ? "DESC" : "ASC";
      await this.getChangeLogs();
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-7">
        <div class="card">
          <div class="card-body">
            <label
              v-if="!cashoutModule.access.update"
              class="form-label medium fw-bold text-danger mb-2"
              style="padding-bottom: 10px"
            >
              Note: Your access is limited. You cannot update a Cashout.
            </label>
            <div class="border-bottom-gray">
              <label class="mb-0">Cashout Details</label>
            </div>

            <b-row class="mt-4">
              <b-col>
                <label class="mb-0">Reference Number:</label>
              </b-col>
              <b-col class="ta-right">
                <div>{{ cashout.txn_ref_id }}</div>
              </b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col>
                <label class="mb-0">Store Name:</label>
              </b-col>
              <b-col class="ta-right">
                <div>{{ cashout.store_name }}</div>
              </b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col>
                <label class="mb-0">Store Owner:</label>
              </b-col>
              <b-col class="ta-right">
                <div>{{ cashout.store_owner }}</div>
              </b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col>
                <label class="mb-0">SSS Mobile Number:</label>
              </b-col>
              <b-col class="ta-right">
                <div>{{ cashout.sss_mobile_no != 0 ? cashout.sss_mobile_no : '' }}</div>
              </b-col>
            </b-row>

            <b-row class="mt-3 mb-1">
              <b-col class="d-flex align-items-center">
                <label class="mb-0">Status:</label>
              </b-col>
              <b-col class="ta-right">
                <b-form-select
                  v-if="cashout.cashout_type == 'other'"
                  style="width: 10rem !important"
                  :options="setStatusOptions"
                  class="form-select rounded-0 rounded-start rounded-end shadow-none ms-auto"
                  v-model="cashout.status"
                  size="sm"
                  :class="{
                    'pending-color-code': cashout.status == 'processing',
                    'on-hold-color-code': cashout.status == 'on hold',
                    'confirmed-color-code': cashout.status == 'confirmed',
                    'declined-color-code': cashout.status == 'rejected',
                    'disabled-confirmed': prevCashoutValue.status == 'confirmed',
                    'disabled-declined': prevCashoutValue.status == 'rejected',
                  }"
                  :disabled="
                    prevCashoutValue.status == 'confirmed' ||
                    prevCashoutValue.status == 'rejected'
                  "
                  @change="cashout.remarks = ''; submitted = false; remarks = '';"
                ></b-form-select>
                <div v-else 
                  :class="{
                    'processing-status': cashout.status == 'processing',
                    'success-status': cashout.status == 'success',
                    'failed-status': cashout.status == 'failed'
                  }">
                  {{ cashout.status }}
                </div>
              </b-col>
            </b-row>

            <b-row class="mt-4">
              <b-col>
                <label class="mb-0">Transaction Date & Time:</label>
              </b-col>
              <b-col class="ta-right">
                <div>{{ cashout.txn_datetime | formatDate }}</div>
              </b-col>
            </b-row>
            
            <b-row class="mt-3 d-flex flex-row" v-if="cashout.cashout_type == 'other'">
              <b-col class="d-flex align-items-center">
                <label class="mb-0">Release Date:</label>
              </b-col>
              <b-col class="ta-right">
                <div
                  class="text-body m-0"
                  v-b-tooltip.hover.right
                  title="Please set the Status into Confirmed first"
                  v-if="cashout.status != 'confirmed'"
                  >
                  <flat-pickr
                    :disabled="cashout.status != 'confirmed'"
                    placeholder="Select Release Date"
                    v-model="dummyReleaseDate"
                    class="form-control"
                    style="width: fit-content; cursor: not-allowed;"
                  ></flat-pickr>
                </div>
                <flat-pickr
                  v-if="prevCashoutValue.status != 'confirmed' && cashout.status == 'confirmed'"
                  :disabled="cashout.status != 'confirmed'"
                  v-model="cashout.release_datetime"
                  :config="rangeOptions"
                  placeholder="Select Release Date"
                  class="form-control"
                  style="width: fit-content"
                ></flat-pickr>
                <div v-if="prevCashoutValue.status == 'confirmed'">{{ cashout.release_datetime | formatDateOnly }}</div>
              </b-col>
            </b-row>

            <b-row class="" :class="{ 'mt-3': cashout.cashout_type != 'other', 'mt-4': cashout.cashout_type == 'other'}">
              <label class="mb-0">Remarks:</label>
              <div>
                <multiselect
                  v-if="cashout.status == 'on hold' || cashout.status == 'rejected'"
                  :multiple="true"
                  v-model="remarks"
                  :options="remarksOptions"
                  track-by="value"
                  label="text"
                  name="cashoutRemarks"
                  select-label="Click to select"
                  deselect-label="Click to remove"
                  placeholder="Select Reason"
                  :allow-empty="true"
                  :preselect-first="false"
                  :hide-selected="true"
                  :close-on-select="false"
                  :class="{ invalid: submitted && $v.remarks.$error, }"
                ></multiselect>

                <div v-else>
                  <b-form-textarea 
                    id="textarea"
                    v-model="cashout.remarks"
                    placeholder="Type remarks..."
                    rows="3"
                    max-rows="6"
                    maxlength="100"
                    :disabled="cashout.cashout_type != 'other'"
                  ></b-form-textarea>
                  <div class="text-muted mt-1">
                    {{ cashout.remarks != null ? cashout.remarks.length : 0 }} / 100
                  </div>
                </div>

                <div v-if="cashout.status == 'on hold' && (submitted && $v.remarks.$error)" class="text-danger">
                  <span v-if="cashout.status == 'on hold' && !$v.remarks.required">Reason is required.</span>
                </div>

                <div v-if="(cashout.status == 'rejected') && (submitted && $v.remarks.$error)" class="text-danger">
                  <span v-if="cashout.status == 'rejected' && !$v.remarks.required">Reason is required.</span>
                </div>
              </div>
            </b-row>

            <b-row class="mt-2 d-flex flex-row">
              <div>
                <label class="mb-0">Internal Remarks:</label>
                <b-form-textarea 
                  id="textarea"
                  v-model="cashout.internal_remarks"
                  placeholder="Type internal remarks..."
                  rows="3"
                  max-rows="6"
                  maxlength="100"
                ></b-form-textarea>
                <div class="text-muted mt-1">
                  {{ cashout.internal_remarks != null ? cashout.internal_remarks.length : 0 }} / 100
                </div>
              </div>
            </b-row>

            <b-row class="mt-3">
              <b-col>
                <label class="mb-0">Withdrawal Amount:</label>
              </b-col>
              <b-col class="ta-right">
                <div>PHP {{ cashout.amount }}</div>
              </b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col>
                <label class="mb-0">Wallet Type:</label>
              </b-col>
              <b-col class="ta-right">
                <div>{{ cashout.wallet_type }}</div>
              </b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col>
                <label class="mb-0">Account Name:</label>
              </b-col>
              <b-col class="ta-right">
                <div>{{ cashout.account_name }}</div>
              </b-col>
            </b-row>

            <b-row class="mt-3 align-items-center">
              <b-col>
                <label class="mb-0">Account Number:</label>
              </b-col>
              <b-col class="ta-right">
                <div>{{ cashout.account_no }}</div>
              </b-col>
            </b-row>

            <b-row class="mt-3 align-items-center">
              <b-col>
                <label class="mb-0">Email:</label>
              </b-col>
              <b-col class="ta-right">
                <div>{{ cashout.recipient_email }}</div>
              </b-col>
            </b-row>

            <b-row class="mt-3 align-items-center" v-if="cashout.cashout_type == 'other'">
              <b-col>
                <label class="mb-0">Acknowledgement Receipt:</label>
              </b-col>
              <b-col class="ta-right">
                <b-link :href="cashout.ar_upload" target="_blank">View Receipt</b-link>
              </b-col>
            </b-row>
            
            <div class="d-flex flex-row align-items-center mt-5">
              <div class="align-items-center">
                <label>Change Log: &nbsp;</label>
                <b-link @click="showReasonLogsModal">View</b-link>
              </div>
              <div class="ms-auto">
                <b-button
                  v-if="cashout.cashout_type == 'other'"
                  :disabled="!cashoutModule.access.update"
                  variant="primary me-2 custom-button-width"
                  @click="updateCashout"
                  >Update</b-button
                >
                <b-button
                  variant="light custom-button-width"
                  @click="$router.back()"
                  >Close</b-button
                >
              </div>
            </div>
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <!-- Cashout Change Logs Modal -->
    <b-modal
      v-model="showLogsModal"
      size="xl"
      centered
      hide-header
      hide-footer
      hide-header-close
      no-close-on-backdrop
      scrollable
    >
      <form class="px-4 py-3">
        <div class="row">
          <div class="col-lg-12">
            <!-- <div class="card">
            </div> -->
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <h5 class="card-title">Wallet Cashout Log</h5>
                  </div>
                </div>

                <!-- Date Range -->
                <div class="col-md-12">
                  <div class="d-flex flex-wrap mt-3 mb-2 ta-right gap-2">
                    <div class="col-sm-3" style="width: fit-content">
                      <b-form-group description="Filter by date">
                        <flat-pickr
                          v-model="logsDateRange"
                          :config="logsRangeOptions"
                          placeholder="Select a date range"
                          class="form-control"
                          style="width: 250px; display: block !important;"
                        ></flat-pickr>
                      </b-form-group>
                    </div>
                    <div class="col-sm-1" style="width: fit-content">
                      <b-button
                        variant="primary"
                        type="button"
                        @click="
                          isSearching = true;
                          getChangeLogs();
                        "
                        class="px-2 d-flex align-items-center"
                      >
                        <div><i class="bx bx-search bx-fw"></i></div>
                        <div>Search</div>
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <div class="table align-middle table-nowrap">
                  <b-table
                    :items="cashoutChangeLogs"
                    :fields="logsModalfields"
                    responsive="sm"
                    :current-page="logsCurrentPage"
                    :sort-by.sync="logsSortBy"
                    :sort-desc.sync="logsSortDesc"
                    class="table-check"
                    @sort-changed="tableSorting"
                  >
                    <template #cell(modified_by)="data">
                      <p class="text-body m-0">{{ data.item.updated_by }}</p>
                    </template>

                    <template #cell(status)="data">
                      <p class="text-body m-0 text-capitalize">
                        {{ data.item.status }}
                      </p>
                    </template>

                    <template #cell(release_date)="data">
                      <p class="text-body m-0">{{ data.item.release_datetime | formatDateOnly}}</p>
                    </template>

                    <template #cell(remarks)="data">
                      <div
                        class="text-body m-0"
                        v-b-tooltip.hover.bottom
                        :title="data.item.remarks"
                        v-if="data.item.remarks != null && data.item.remarks.length > 50"
                      >
                        <span>
                          {{ `${data.item.remarks.substring(0, 50)}...` }}
                        </span>
                      </div>
                      <p class="text-body m-0" v-else>
                        {{ data.item.remarks != 'null' ?  data.item.remarks : '' }}
                      </p>
                    </template>

                    <template #cell(modified_at)="data">
                      <p class="text-body m-0">
                        {{ data.item.updated_at | formatDate }}
                      </p>
                    </template>
                  </b-table>
                </div>
              </div>
              <!-- end table responsive -->

              <div
                class="row g-0 text-center"
                v-if="mcpCashoutChangeLogsTotal == 0"
              >
                <span>No data to display.</span>
              </div>
              <div
                class="row g-0 text-center text-sm-start"
                v-if="mcpCashoutChangeLogsTotal > 10"
              >
                <!-- end col -->
                <div class="col-sm-12">
                  <div class="row">
                    <div class="col">
                      <div class="form-group row pull-left">
                        <label for="staticEmail" class="col-sm-6 col-form-label"
                          >Display:</label
                        >
                        <div class="col-sm-6">
                          <b-form-group label-for="display-record">
                            <b-form-select
                              class="form-select shadow-none w-fit"
                              id="display-record"
                              v-model="logsPerPage"
                              :options="logsPageOptions"
                              @change="getChangeLogs()"
                            ></b-form-select>
                          </b-form-group>
                        </div>
                      </div>
                      <div
                        class="dataTables_paginate paging_simple_numbers float-end"
                        v-if="mcpCashoutChangeLogsTotal > logsPerPage"
                      >
                        <!-- pagination -->
                        <b-pagination
                          class="pagination-rounded"
                          v-model="logsCurrentPage"
                          :total-rows="mcpCashoutChangeLogsTotal"
                          :per-page="logsPerPage"
                          @input="getChangeLogs()"
                        ></b-pagination>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- end col -->
              </div>
            </div>
          </div>
        </div>
        <div class="text-end mt-3 px-1">
          <b-button variant="light" class="w-sm" @click="closeLogsModal()"
            >Close</b-button
          >
        </div>
      </form>
    </b-modal>
    <!-- End Cashout Change Logs Modal -->
  </div>
</template>
<style>
.custom-checkbox-method label {
  margin-left: 10px;
}

.custom-checkbox-method input {
  margin-left: 15px;
}

.required-input {
  color: red;
}

.calendar-icon {
  display: block;
  font-size: 20px;
  padding: 8px;
  background-color: grey;
}

.border-bottom-gray {
  border-bottom: solid #ededed !important;
}

.custom-button-width {
  width: 6rem !important;
}

.pending-color-code {
  border-color: #831118 !important;
  color: #831118 !important;
}

.on-hold-color-code {
  border-color: #dc7512 !important;
  color: #dc7512 !important;
}

.confirmed-color-code {
  border-color: #e3e5e8 !important;
  color: #fff !important;
  background-color: #508f30 !important;
}

.declined-color-code {
  border-color: #868686 !important;
  color: #868686 !important;
}

.disabled-confirmed {
  border-color: #e3e5e8 !important;
  color: #fff !important;
  background-color: #508f30 !important;
  cursor: not-allowed;
}

.disabled-declined {
  border-color: #868686 !important;
  color: #868686 !important;
  cursor: not-allowed;
}

.form-control {
    display: inline-flex !important;
}

.processing-status {
  text-transform: capitalize; 
  color: #831118;
}

.success-status {
  text-transform: capitalize; 
  color: #508f30;
}

.failed-status {
  text-transform: capitalize; 
  color: #868686;
}

.multiselect.invalid .multiselect__tags {
  border-color: #f34e4e;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f34e4e'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f34e4e' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}

.invalid ~ .invalid-feedback {
  display: block;
}

.multiselect__option--highlight,
.multiselect__option--highlight::after {
  background: #f8f9fa;
  color: #495057;
}

.multiselect__tag {
  background-color: #e73092 !important;
  border-color: #e73092 !important;
  margin-bottom: 0 !important;
  font-weight: 400 !important;
}

.multiselect__tag-icon:after {
  color: #fff !important;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background-color: #e73092 !important;
}

.invalid-remarks {
  border-color: #F34E4E !important;
}
</style>
